import { CRM_API, RequestHelper } from "utils";

const RUTA = "cargaMasiva";

export const CargaMasivaService = (() => {
  /**
   * Descarga la plantilla Excel para la entidad indicada.
   * Devuelve un Blob.
   */
  const descargarPlantilla = function (entidad) {
    return new Promise((res) => res(entidad)).then((e) => {
      return RequestHelper(CRM_API).get(`${RUTA}/descargarPlantilla`, { entidad: e }, true);
    });
  };

  /**
   * Envía el archivo Excel al servidor para ser parseado.
   * Usa postWithFiles: construye FormData con campo "json" (el objeto serializado) + File-0.
   * Devuelve la lista de filas del tipo de entidad indicado.
   */
  const procesarArchivo = function (entidad, archivo) {
    return new Promise((res) => res({ entidad, archivo })).then(({ entidad: e, archivo: f }) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/procesarArchivo`, {
        Entidad: e,
        Files: [f],
      });
    });
  };

  /**
   * Graba las filas revisadas por el usuario.
   * Devuelve CargaMasivaResultadoDTO con resultado por fila.
   */
  const guardar = function (body) {
    return new Promise((res) => res(body)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/guardar`, data);
    });
  };

  return {
    descargarPlantilla,
    procesarArchivo,
    guardar,
  };
})();
